
export class ProjectsRequestModel {
  projectCode : string;
  projectName : string;
  projectDescription : string;
  updatedUser ?: string;
  createdUser ?: string;
  versionFlag: number;
}

export const ProjectsRequestDefault: ProjectsRequestModel = {
  projectCode: '',
  projectName : '',
  projectDescription : '',
  versionFlag: 0,
  updatedUser: '',
  createdUser: ''
}

